<template>
  <div class="DistributorList">
    <div class="row">
      <div
        v-for="item in distributors"
        :key="item.id"
        class="col-12 col-sm-6 col-md-6 col-lg-4"
      >
        <DistributorCard :distributor="item" />
      </div>
    </div>
  </div>
</template>

<script>
import DistributorCard from '@/components/distributor/Card.vue';

export default {
  name: 'DistributorList',
  components: {
    DistributorCard,
  },
  props: {
    distributors: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .DistributorCard {
  margin-bottom: 15px;
}
</style>
